import { createContext } from 'react'

export const GuestTokenContext = createContext('')
export const UserTokenContext = createContext('')
